exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  padding: 4px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.thinking {\n  opacity: 0.65;\n}\n\n.dots {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 6px;\n}\n\n.dots i {\n  width: 6px; \n  height: 6px;\n  border-radius: 50%;\n  background: currentColor; \n  opacity: 0.25;\n  transform: translateY(0);\n  animation: dotPulse 1s infinite ease-in-out;\n}\n\n.dots i:nth-child(1) { \n  animation-delay: 0s; \n}\n.dots i:nth-child(2) { \n  animation-delay: 0.15s; \n}\n.dots i:nth-child(3) { \n  animation-delay: 0.3s; \n}\n\n@keyframes dotPulse {\n  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }\n  40% { opacity: 1; transform: translateY(-6px); }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/components/ai-thinking/ai-thinking.component.css
// module id = ../../../../../src/app/ai-chat/components/ai-thinking/ai-thinking.component.css
// module chunks = main